import React from "react";
import "./BoardProgressBar.scss";

const BoardProgressBar = ({
  value = 0,
  max = 100,
  label,
  showPercent = true,
  className = "",
}) => {
  const safeMax = max > 0 ? max : 1;
  const percent = Math.min(100, Math.round((value / safeMax) * 100));

  return (
    <div className={`pb-progress ${className}`.trim()}>
      {(label || showPercent) && (
        <div className="pb-progress__header">
          {label && <span>{label}</span>}
          {showPercent && <span>{percent}%</span>}
        </div>
      )}
      <div className="pb-progress__track" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100}>
        <div className="pb-progress__fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
};

export default BoardProgressBar;
